/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, no-extra-boolean-cast, @typescript-eslint/no-unsafe-call */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable */
/* istanbul ignore file */
import React, { useMemo } from 'react';
import { Box, Heading, Flex, Text, VStack, Skeleton, HStack, useToast, Checkbox, Textarea } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import isArray from 'lodash/isArray';
import { RiLock2Fill } from 'react-icons/ri';
import ImageView from '../../../../../app/components/ImageView';
import PixelatedImage from '../../../../../assets/img/pixelated-image.png';
import { fieldLabel, schemaFields } from '../../../../administration/hireForm/formBuilderSchemas/formBuilder.schema';
import { ImagePreviewModal } from '../../../../../app/components/ImagePreviewModal';
import { formBuilderType, LabelSchema } from '../../../../administration/hireForm/formElements/formBuilderSchema';
import {
  Candidate,
  CandidateHireDetailsAnswer,
  CandidateHireFormDetailResponse,
  CandidateHireFormDetailResponseWithError,
  SeekerHireDetail,
} from '../../../../../firebase/firestore/documents/candidate';
import colors from '../../../../../styles/colors';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { FieldDefinition, ResubmissionRequest } from './HireFormType';
import { formatPhoneNumber, getPhoneRegion } from '../../../../../utils/PhoneUtils';
import { getConsistentDateFormat } from '../../../../../utils/dateUtils';

interface SeekerHireFormAnswersProps {
  selectedCandidate: Candidate;
  requestResubmission?: boolean;
  registerValidation?: (validateFn: () => boolean, getFields: () => ResubmissionRequest) => void;
  supportedResubmissionFields?: FieldDefinition[];
}

type THireDetailsValue = {
  questionId: string;
  field: string;
  label: string;
  answer: string | null;
  images: string[] | null;
  inputType: string;
  followUpField: schemaFields;
};

type HireSectionT = {
  section: string;
  sectionTitle: string;
  fields: (THireDetailsValue | HireSectionT)[];
};

export default function SeekerHireFormAnswers({
  selectedCandidate,
  requestResubmission,
  registerValidation,
  supportedResubmissionFields,
}: SeekerHireFormAnswersProps) {
  const { t, i18n } = useTranslation('hireDetail');
  const [currentLanguage, setCurrentLanguage] = React.useState<string>(i18n.language);
  const toast = useToast();
  const { getSeekerHierDetails, loadHireDetailOfCandidate } = useStoreActions((actions) => actions.candidate);

  const [hireDetailOfCandidate, setHireDetailOfCandidate] = React.useState<CandidateHireFormDetailResponse | undefined>(
    undefined,
  );
  const [hireDetails, setHireDetails] = React.useState<CandidateHireDetailsAnswer[]>([]);
  const [filteredHireDetails, setFilteredHireDetails] = React.useState<HireSectionT[]>();
  const [isLoading, setIsLoading] = React.useState(false);

  const superOwners = useStoreState((s) => s.app.accounts?.superOwners);
  const userId = useStoreState((s) => s.app.user?.id);

  const [resubmissionFields, setResubmissionFields] = React.useState<ResubmissionRequest>([]);
  const [validationErrors, setValidationErrors] = React.useState<Record<string, string>>({});

  const validateResubmissionFields = () => {
    const errors: Record<string, string> = {};
    resubmissionFields.forEach((item) => {
      if (!item.comment?.trim()) {
        errors[item.field] = 'Comment is required when field is checked for resubmission';
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  React.useEffect(() => {
    if (registerValidation) {
      registerValidation(validateResubmissionFields, () => resubmissionFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerValidation, resubmissionFields]);

  const superAdminFields = [schemaFields.workPermitImageUrl, schemaFields.chequebookImageUrl, schemaFields.documentIdImageUrl];
  const defaultFields = [
    schemaFields.firstName,
    schemaFields.middleName,
    schemaFields.lastName,
    schemaFields.email,
    schemaFields.phoneNumber,
  ];

  const isSuperAdmin = (): boolean => {
    if (!superOwners || !userId) {
      return false;
    }
    return superOwners?.includes(userId);
  };

  const redactNumber = (str: string) => {
    if (!isSuperAdmin() && str) {
      const { length } = str;
      const hiddenPart = length > 3 ? '*'.repeat(length - 3) : /* istanbul ignore next */ '';
      return hiddenPart + str.substring(length - 3);
    }
    return str;
  };
  const checkResubmissionField = (field: string) => {
    let matchField = field;

    const isFieldInDefault = defaultFields.includes(field as schemaFields);
    const isFieldNotInHireDetails = !hireDetails.some((item) => item.field === field);

    if (isFieldInDefault && isFieldNotInHireDetails) {
      const modifiedFollowUpField = hireDetails.find((item) => item.followUpField === field);
      if (modifiedFollowUpField?.field) {
        matchField = modifiedFollowUpField.field;
      }
    }

    const errorMsg = selectedCandidate.hireDetailsResubmissionRequest?.find((item) => item.field === matchField)?.comment;
    if (!!errorMsg?.trim()) {
      return (
        <Text color="tomato" fontSize="xs">
          {errorMsg}
        </Text>
      );
    }
    return '';
  };

  const isResubmissionAvailableOnThisInputType = (inputType: string) => {
    switch (inputType) {
      case 'signature':
        return false;
      case 'documentReview':
        return false;

      default:
        return true;
    }
  };

  const hasResubmissionField = (field: string) => {
    let matchField = field;

    const isFieldInDefault = defaultFields.includes(field as schemaFields);
    const isFieldNotInHireDetails = !hireDetails.some((item) => item.field === field);

    if (isFieldInDefault && isFieldNotInHireDetails) {
      const modifiedFollowUpField = hireDetails.find((item) => item.followUpField === field);
      if (modifiedFollowUpField?.field) {
        matchField = modifiedFollowUpField.field;
      }
    }

    return !!selectedCandidate.hireDetailsResubmissionRequest?.find((item) => item.field === matchField);
  };

  const formatName = (name: string) => {
    /* istanbul ignore next */
    if (name === 'ssn' || name === 'sin') return name?.toUpperCase();
    return name
      ?.replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
      .trim();
  };

  const resolveForCurrentLanguage = React.useCallback(
    (value: Record<string, string | null | undefined> | null | undefined, fallback = ''): string => {
      if (!value) return fallback;

      // 1. Exact language match
      const direct = value[currentLanguage];
      if (direct) return direct;

      // 2. First available translation
      for (const key in value) {
        const v = value[key];
        if (v) return v;
      }

      // 3. Fallback
      return fallback;
    },
    [currentLanguage],
  );

  const getLabelTranslation = (label: LabelSchema, field: string) => {
    const fieldDefinition = fieldLabel[field as keyof typeof fieldLabel];
    const translatedLabel = fieldDefinition?.[currentLanguage];
    const isTranslatedLabelAvailable = Boolean(translatedLabel?.trim());

    let currentLabelText = label?.[currentLanguage];
    const isCurrentLabelTextAvailable = Boolean(currentLabelText?.trim());

    if (!isCurrentLabelTextAvailable) {
      currentLabelText = isTranslatedLabelAvailable ? translatedLabel : label.en;
    }

    return formatName(currentLabelText || '');
  };

  const mappedHireDetails = (item: any) => {
    const acc: THireDetailsValue[] = [];
    const newItem = {
      questionId: item.questionId,
      field: item.field,
      label: getLabelTranslation(item.label, item.field),
      images: null,
      inputType: item.inputType,
      followUpField: item.followUpField,
    };

    switch (item.inputType) {
      case formBuilderType.info:
        break;
      case formBuilderType.documentReview:
      case formBuilderType.documentPreview: {
        let answer = item.answer?.confirmedDate;
        if (Boolean(answer?.trim())) {
          if (!isSuperAdmin()) {
            answer = moment(answer).format('MMM ** YYYY');
          } else {
            answer = getConsistentDateFormat(answer, 'full');
          }
          acc.push({ ...newItem, answer });
        }
        break;
      }
      case formBuilderType.address: {
        const addressFieldsOrder = [
          schemaFields.addressLineOne,
          schemaFields.addressLineTwo,
          schemaFields.city,
          schemaFields.region,
          schemaFields.postalCode,
          schemaFields.country,
        ];

        const addressParts = addressFieldsOrder.map((key) => item.answer?.[key]).filter((val) => !!val?.trim());

        const combinedAddress = addressParts.join(', ');

        acc.push({
          ...newItem,
          answer: combinedAddress,
        });

        break;
      }
      case formBuilderType.image:
      case formBuilderType.file:
      case formBuilderType.signature: {
        acc.push({ ...newItem, answer: null, images: item.answer });
        break;
      }
      case formBuilderType.radio:
      case formBuilderType.singleCheckbox: {
        const answer = item.answer?.text?.[currentLanguage];
        if (Boolean(answer?.trim())) {
          acc.push({ ...newItem, answer });
        }
        break;
      }

      case formBuilderType.checkbox: {
        /* istanbul ignore else */
        if (isArray(item.answer)) {
          const answer = item.answer?.reduce((checkAnswer: string, ans: any, index: number) => {
            // eslint-disable-next-line
            const newAns = `${checkAnswer}${ans?.text?.[currentLanguage]}${index === item.answer.length - 1 ? '' : ', '}`;
            return newAns;
          }, '');
          acc.push({ ...newItem, answer });
        }
        break;
      }
      case formBuilderType.yesNo: {
        // const hasFollowUps = item.followups?.length > 0;
        // if (hasFollowUps) {
        //   item.followups?.forEach((followup: any) => {
        //     acc.push(...mappedHireDetails(followup));
        //   });
        // }
        const answer = item.answer?.text?.[currentLanguage];
        if (Boolean(answer?.trim())) {
          acc.push({ ...newItem, answer });
        }
        break;
      }
      case formBuilderType.sin:
      case formBuilderType.ssn:
      case formBuilderType.branchTransitNumber:
      case formBuilderType.financialInstitutionNumber:
      case formBuilderType.bankAccountNumber:
      case formBuilderType.routingNumber: {
        acc.push({ ...newItem, answer: redactNumber(item.answer) });
        break;
      }
      case formBuilderType.date: {
        // eslint-disable-next-line
        let answer = item?.answer;
        if (!isSuperAdmin() && item.field === schemaFields.dateOfBirth) {
          answer = moment(answer).format('MMM ** YYYY');
        } else {
          answer = getConsistentDateFormat(answer, 'full');
        }
        acc.push({ ...newItem, answer });
        break;
      }
      case formBuilderType.phone: {
        let phone = item?.answer;
        if (phone) {
          phone = formatPhoneNumber(
            phone,
            getPhoneRegion(phone, selectedCandidate?.countryCode) || selectedCandidate?.countryCode || 'CA',
            true,
          );
        }
        acc.push({ ...newItem, answer: phone || '--' }); // fallback to --- when empty
        break;
      }
      default: {
        acc.push({ ...newItem, answer: item.answer });
        break;
      }
    }

    return acc;
  };

  // function isSection(section: HireSectionT): item is HireSectionT {
  //   return section.fields?.some((f) => 'section' in f);
  // }

  const filterHireDetails = (data: any[]) => {
    const defaultData = defaultFields?.reduce((acc, field) => {
      let answer = hireDetailOfCandidate?.seekerHireDetail?.[field as keyof SeekerHireDetail];

      if (!answer && defaultFields.includes(field as schemaFields)) {
        const hasNoHireDetailField = !hireDetails.some((item) => item.field === field);
        const hasYesNoFollowUp = hireDetails.some(
          (item) => item.followUpField === field && item.inputType === formBuilderType.yesNo,
        );
        if (hasNoHireDetailField && hasYesNoFollowUp) {
          answer = 'N/A';
        } else {
          answer = '--';
        }
      }

      // if (!data.some((item) => item.field === field)) {
      acc.push({
        field,
        label: { en: fieldLabel[field as keyof typeof fieldLabel].en, fr: fieldLabel[field as keyof typeof fieldLabel].fr },
        answer,
        section: t('candidateInformation'),
        inputType: field === schemaFields.phoneNumber ? formBuilderType.phone : undefined,
        sectionTitle: { [currentLanguage]: t('candidateInformation') },
      });
      // }
      // eslint-disable-next-liney
      return acc;
    }, [] as any[]);

    // Add followUpField filter step before building sections
    // const followUpFieldsInUse = new Set(data.map((item) => item.field));
    // const filtered = data.filter((item) => !item.followUpField || !followUpFieldsInUse.has(item.followUpField));
    const filtered = data.filter((item) => {
      if (!item.followUpField) return true;
      return !defaultFields.includes(item.followUpField);
    });

    const existingFields = new Set(hireDetails.map((item) => item.field));

    const filteredAlreadyExistingHireDetails = filtered.filter((item) => {
      if (item.followUpField && existingFields.has(item.followUpField)) {
        return false;
      }

      return true;
    });

    // eslint-disable-next-line
    const res = [
      ...defaultData,
      ...filteredAlreadyExistingHireDetails?.filter((item) => !defaultFields?.includes(item.field)),
    ].reduce((acc: HireSectionT[], item) => {
      if (!item.answer && !defaultFields.includes(item.field)) {
        // eslint-disable-next-line
        return acc;
      }
      const sectionName = formatName(item.section);
      const parentSectionName = formatName(item.parentSection);
      const hasParentSection = !!parentSectionName;
      if (hasParentSection) {
        const parentSectionIndex = acc?.findIndex((group: any) => group.section === parentSectionName);
        const mappedDetails = mappedHireDetails(item);
        if (parentSectionIndex === -1) {
          acc.push({
            section: parentSectionName,
            sectionTitle: resolveForCurrentLanguage(item.parentSectionTitle, parentSectionName),
            fields: [
              {
                section: sectionName,
                fields: [...mappedDetails],
                sectionTitle: resolveForCurrentLanguage(item.sectionTitle, sectionName),
              },
            ],
          });
        } else {
          const sectionIndex = acc[parentSectionIndex]?.fields?.findIndex((group: any) => group.section === sectionName);
          /* istanbul ignore else */
          if (sectionIndex === -1) {
            acc[parentSectionIndex].fields.push({
              section: sectionName,
              fields: [...mappedDetails],
              sectionTitle: resolveForCurrentLanguage(item.sectionTitle, sectionName),
            });
          } else if ('fields' in acc[parentSectionIndex].fields[sectionIndex]) {
            (acc[parentSectionIndex].fields[sectionIndex] as HireSectionT)?.fields?.push(...mappedDetails);
          }
        }
      } else {
        const sectionIndex = acc?.findIndex((group: any) => group.section === sectionName);
        const mappedDetails = mappedHireDetails(item);
        if (sectionIndex === -1) {
          // eslint-disable-next-line
          acc.push({
            section: sectionName,
            fields: [...mappedDetails],
            sectionTitle: resolveForCurrentLanguage(item.sectionTitle, sectionName),
          });
        } else {
          acc[sectionIndex]?.fields.push(...mappedDetails);
        }
      }

      // eslint-disable-next-line
      return acc;
    }, [] as HireSectionT[]);

    function filterEmptySections(sections: HireSectionT[]): HireSectionT[] {
      return sections
        .map((section) => {
          // Recursively filter the nested `fields` if they are `HireSectionT` types
          const filteredFields = section.fields.filter((field) => {
            if ((field as HireSectionT).fields) {
              // Recursively filter nested sections
              return (field as HireSectionT).fields.length > 0;
            }
            return true; // Keep non-HireSectionT items
          });

          // Return the section only if it has non-empty fields
          return { ...section, fields: filteredFields };
        })
        .filter((section) => section.fields.length > 0); // Remove sections with empty fields
    }

    // eslint-disable-next-line
    return filterEmptySections(res);
  };
  const ignoredFields = ['socialInsuranceNumber', 'city', 'country', 'bankAccountNumber'];

  function restructureSectionsWithIgnoreFields(sections: HireSectionT[], ignoreFields: string[]): HireSectionT[] {
    const result: HireSectionT[] = [];

    let lastValidParentSection: HireSectionT | null = null;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const flattenedFields: THireDetailsValue[] = [];

      let hasIgnoreField = false;

      // Flatten the section and check if any of the fields are in the ignoreFields array
      for (const item of section.fields) {
        if ('section' in item) {
          // It's a nested section, so we need to recursively check for ignore fields in its fields
          const nestedFields = restructureSectionsWithIgnoreFields([item], ignoreFields);
          flattenedFields.push(...(nestedFields[0].fields as any)); // Add nested fields from recursive result
        } else {
          // It's a regular field
          if (ignoreFields.includes(item.field)) {
            hasIgnoreField = true;
          }
          flattenedFields.push(item);
        }
      }

      // If the section has an ignored field, move its fields to the previous parent or sibling section
      /* istanbul ignore next */
      if (hasIgnoreField) {
        /* istanbul ignore if */
        if (lastValidParentSection) {
          // Move the fields to the previous parent section
          lastValidParentSection.fields.push(...flattenedFields);
        } else if (i > 0) {
          // Move the fields to the previous sibling section if no parent is available
          result[i - 1].fields.push(...flattenedFields);
        } else {
          // If no parent or sibling, leave the section as it is
          result.push({ section: section.section, fields: flattenedFields, sectionTitle: section.sectionTitle });
        }
      } else {
        // If the section does not have any ignoreField, leave it as is
        result.push({ section: section.section, fields: flattenedFields, sectionTitle: section.sectionTitle });
        lastValidParentSection = result[result.length - 1];
      }
    }

    return result;
  }

  const loadCandidateHireDetail = async () => {
    const hireDetailResponse = await loadHireDetailOfCandidate({ candidateId: selectedCandidate.id });
    const { status, title } = hireDetailResponse as CandidateHireFormDetailResponseWithError;
    if (status) {
      toast({
        title: `${title}`,
        status: 'error',
        isClosable: true,
      });
    } else {
      setHireDetailOfCandidate(hireDetailResponse as CandidateHireFormDetailResponse);
    }
  };

  const loadHireDetail = React.useCallback(async () => {
    try {
      setIsLoading(true);
      const hireDetailsResponse = await getSeekerHierDetails({ candidateId: selectedCandidate.id });
      await loadCandidateHireDetail();
      setCurrentLanguage(
        hireDetailsResponse?.data?.answers?.languages?.includes(i18n.language)
          ? i18n.language
          : hireDetailsResponse?.data?.answers?.defaultLanguage || 'en',
      );
      setHireDetails(hireDetailsResponse?.data?.answers?.answers ?? []);
    } finally {
      setIsLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCandidate, setHireDetails, getSeekerHierDetails]);

  React.useEffect(() => {
    const hireDetailsData = [...hireDetails];
    if (hireDetailOfCandidate?.seekerHireDetail.signatureImageUrl) {
      const signatureUrl = isArray(hireDetailOfCandidate?.seekerHireDetail.signatureImageUrl)
        ? hireDetailOfCandidate?.seekerHireDetail.signatureImageUrl
        : [hireDetailOfCandidate?.seekerHireDetail.signatureImageUrl];
      hireDetailsData.push({
        questionId: 'finalSignature',
        inputType: formBuilderType.signature,
        field: 'signature',
        answer: signatureUrl,
        section: 'Final Signature',
        sectionTitle: {
          en: 'Final Signature',
          fr: 'Signature finale',
        },
        label: {
          en: 'Final Signature',
          fr: 'Signature finale',
        },
        order: 0,
        isInfo: false,
        questionText: {
          en: 'question',
          fr: 'question',
        },
      });
    }
    setFilteredHireDetails(restructureSectionsWithIgnoreFields(filterHireDetails(hireDetailsData), ignoredFields));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hireDetails, i18n, hireDetailOfCandidate]);

  React.useEffect(() => {
    // eslint-disable-next-line
    loadHireDetail();

    // eslint-disable-next-line
  }, []);

  const supportedFieldMap = useMemo(() => {
    const map = new Map<string, string>();
    (supportedResubmissionFields ?? []).forEach(({ field, followUpField }) => {
      map.set(field, field);
      if (followUpField) {
        map.set(followUpField, field);
      }
    });
    return map;
  }, [supportedResubmissionFields]);

  if (isLoading)
    return (
      <VStack py={5}>
        {Array(5)
          .fill(0)
          .map((_, index) => {
            const flexBasis1 = `${Math.floor(Math.random() * (40 - 20 + 1) + 10)}%`;
            const flexBasis2 = `${Math.floor(Math.random() * (30 - 20 + 1) + 10)}%`;
            return (
              <HStack key={index} justify="space-between" spacing={2} px={5} width="100%" data-testid="skeleton">
                <Skeleton key={`${index}-1`} height="4" flexBasis={flexBasis1} colorScheme={colors.black} />
                <Skeleton key={`${index}-2`} height="3" flexBasis={flexBasis2} colorScheme={colors.gray[400]} />
              </HStack>
            );
          })}
      </VStack>
    );

  const sectionRenderer = (section: HireSectionT, isSubSection = false) => {
    const sectionName = section?.sectionTitle;

    const values = section.fields;
    /* istanbul ignore if */
    if (!values?.length) return null;
    return (
      <>
        <Box key={sectionName} paddingLeft={/* istanbul ignore next */ isSubSection ? 4 : 0}>
          {!(sectionName === 'Final  Signature' || sectionName === 'Default') && (
            <Heading px={5} as="h3" fontSize="md">
              {sectionName}
            </Heading>
          )}

          <Box
            pb={1}
            borderTop={`1px solid ${colors.gray[50]}`}
            borderBottom={/* istanbul ignore next */ isSubSection ? 'none' : `1px solid ${colors.gray[50]}`}
          >
            {values?.map((value) => {
              /* istanbul ignore if */
              if ('fields' in value) {
                return sectionRenderer(value, true);
              }
              const label = value.label || '';
              const isImage = value.images && value.images.length > 0;
              const isSuperAdminField = superAdminFields.includes(value.field as schemaFields);
              const isOnlyForSuperAdmin = isSuperAdminField && !isSuperAdmin();
              const answer = value.answer || '';
              const images = isOnlyForSuperAdmin && isImage ? value.images?.map(() => PixelatedImage) : value.images;
              // const isChecked = resubmissionFields.some((item) => item.field === value.field);
              // const comment = resubmissionFields.find((item) => item.field === value.field)?.comment || '';
              // Only allow checkbox for supported fields
              // const isSupported = supportedFieldSet.has(value.field);
              const supportedKey = supportedFieldMap.get(value.field);
              const isSupported = !!supportedKey;
              const isChecked = resubmissionFields.some((item) => item.field === supportedKey);
              const comment = resubmissionFields.find((item) => item.field === supportedKey)?.comment || '';

              return (
                <VStack spacing={0} key={value.questionId} px={5}>
                  <Flex alignItems="center" justifyContent="space-between" width="100%">
                    {requestResubmission && isResubmissionAvailableOnThisInputType(value.inputType) && isSupported ? (
                      <Checkbox
                        isChecked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setResubmissionFields((prev) => [...prev, { field: supportedKey!, comment: '' }]);
                          } else {
                            setResubmissionFields((prev) => prev.filter((f) => f.field !== supportedKey));
                          }
                        }}
                        marginRight={2}
                      >
                        <Heading
                          flex="1"
                          as="h6"
                          fontSize="sm"
                          lineHeight="2.2"
                          color={hasResubmissionField(value.field) ? 'tomato' : 'gray.800'}
                          whiteSpace="nowrap"
                        >
                          {label}
                        </Heading>
                      </Checkbox>
                    ) : (
                      <Heading
                        flex="1"
                        as="h6"
                        fontSize="sm"
                        lineHeight="2.2"
                        color={hasResubmissionField(value.field) ? 'tomato' : 'gray.800'}
                        whiteSpace="nowrap"
                      >
                        {label}
                      </Heading>
                    )}

                    {isImage ? (
                      <HStack>
                        {images?.map((image, imageIndex) => (
                          <ImagePreviewModal
                            key={`${image}-${imageIndex}`}
                            isDisabled={isOnlyForSuperAdmin}
                            images={images}
                            getImageKey={(val) => val || ''}
                            getImageSrc={(val) => val || ''}
                            previewTitle={label}
                            selectedImage={image}
                            setTrigger={
                              <ImageView src={image} alt={image} height="40px" width="40px" key={`${image}-${imageIndex}`} />
                            }
                            modalSize="6xl"
                            previewImageHeight="600px"
                          />
                        ))}
                      </HStack>
                    ) : (
                      <Text as="div" fontSize="sm" textAlign="right" flex="1" color="gray.450">
                        {value.inputType === formBuilderType.yesNo && Boolean(value.followUpField) ? 'N/A' : answer}

                        {checkResubmissionField(value.field)}
                      </Text>
                    )}
                  </Flex>

                  {isChecked && requestResubmission && (
                    <Box width="100%" display="flex" flexDirection="column" gap={0}>
                      <Textarea
                        value={comment}
                        onChange={(e) => {
                          setResubmissionFields((prev) =>
                            prev.map((f) => (f.field === supportedKey ? { ...f, comment: e.target.value } : f)),
                          );
                          setValidationErrors((prev) => ({ ...prev, [supportedKey || '']: '' }));
                        }}
                        style={{
                          color: colors.gray[450],
                        }}
                        placeholder={t('hireReview.resubmissionCommentPlaceholder')}
                        border={`1px solid ${colors.input.borderColor} !important`}
                        boxShadow={`0px 0px 0px 1px ${colors.gray[150]}`}
                        fontSize={14}
                        width="100%"
                        padding="8px 12px"
                        backgroundColor={colors.input.background}
                        borderRadius="6px"
                      />

                      <Box minHeight="18px">
                        {supportedKey !== undefined && validationErrors[supportedKey] && (
                          <Text fontSize="xs" color="tomato">
                            {validationErrors[supportedKey]}
                          </Text>
                        )}
                      </Box>
                    </Box>
                  )}

                  {isOnlyForSuperAdmin && (
                    <Text
                      as="div"
                      d="flex"
                      fontSize="xs"
                      color={colors.gray[400]}
                      alignItems="center"
                      justifyContent="flex-end"
                      width="100%"
                    >
                      <RiLock2Fill style={{ marginRight: '5px' }} />
                      {t('noPermissionToViewImage')}
                    </Text>
                  )}
                </VStack>
              );
            })}
          </Box>
        </Box>
      </>
    );
  };

  return (
    <>
      {filteredHireDetails?.map((item) => {
        return sectionRenderer(item);
      })}
    </>
  );
}
